import styled from "styled-components";

export const StyledDialogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
